import { list } from './List/List.i18n.en'
export const login = {
  list,
}
